var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value.staticValue)?_c('span',[_vm._v("\n  "+_vm._s(_vm.value.staticValue)+"\n")]):_c('span',{staticClass:"live-date"},[_vm._v("\n  "+_vm._s(_vm.label)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }